var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "page-associator" } }, [
    _c("div", { staticClass: "display-6 m-2" }, [_vm._v("Page Manager")]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "needs-validation",
        attrs: { id: "page-update-form", novalidate: "" },
      },
      [
        _c("div", { staticClass: "row m-3" }, [
          _c("div", { staticClass: "col-md-9" }, [
            _c(
              "label",
              { staticClass: "m-1 form-label", attrs: { for: "company" } },
              [_vm._v("Company")]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.company,
                    expression: "company",
                  },
                ],
                staticClass: "form-select",
                attrs: { id: "company", required: "" },
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.company = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function ($event) {
                      return _vm.clearPage()
                    },
                  ],
                },
              },
              _vm._l(_vm.companyOptions, function ([key, value]) {
                return _c(
                  "option",
                  {
                    key: value,
                    attrs: { disabled: value === "0" },
                    domProps: { value: value },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(key) +
                        "\n                    "
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.isCompanySelected
          ? _c("div", [
              !_vm.isPageSelected
                ? _c("div", [
                    _vm.isPagesLoading
                      ? _c("div", [_vm._m(0)])
                      : _c("div", [
                          _vm.isDisplayImportPage
                            ? _c("div", [
                                _c("div", { staticClass: "row m-3" }, [
                                  _c("div", { staticClass: "col-md-5" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "m-1",
                                        attrs: { for: "importPageId" },
                                      },
                                      [_vm._v("Page ID")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.importPageRequest.PageID,
                                          expression:
                                            "importPageRequest.PageID",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "importPageId",
                                        placeholder: "Page ID",
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.importPageRequest.PageID,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.importPageRequest,
                                            "PageID",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row m-3" }, [
                                  _c("div", { staticClass: "col-md-5" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "m-1 form-label",
                                        attrs: { for: "pageOwnerType" },
                                      },
                                      [_vm._v("Page Owner")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.importPageRequest.OwnerType,
                                            expression:
                                              "importPageRequest.OwnerType",
                                          },
                                        ],
                                        staticClass: "form-select",
                                        attrs: { id: "pageOwnerType" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.importPageRequest,
                                              "OwnerType",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      _vm._l(
                                        _vm.pageOwnerOptions,
                                        function ([key, value]) {
                                          return _c(
                                            "option",
                                            {
                                              key: value,
                                              domProps: { value: value },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(key) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row m-3" }, [
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: { disabled: _vm.isImporting },
                                        on: { click: _vm.importPage },
                                      },
                                      [
                                        _vm.isImporting
                                          ? _c("span", {
                                              staticClass:
                                                "spinner-border spinner-border-sm",
                                              attrs: {
                                                role: "status",
                                                "aria-hidden": "true",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                                    Import\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary",
                                        attrs: { disabled: _vm.isImporting },
                                        on: { click: _vm.cancelImport },
                                      },
                                      [_vm._v("Cancel")]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.displayImportError
                                  ? _c("div", [
                                      _c("div", { staticClass: "row m-4" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 alert alert-danger",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "display-1 text-danger text-center",
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["far", "xmark"],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "text-center text-danger m-2",
                                              },
                                              [_vm._v("Failure")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass: "text-center m-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.importResponseMessage
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ])
                            : _c("div", [
                                _c("div", { staticClass: "row m-3" }, [
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "m-1",
                                          attrs: { for: "pageSearch" },
                                        },
                                        [
                                          _vm._v(
                                            "Search Existing Managed Pages:"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-md-9" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.pageSearchInput,
                                                expression: "pageSearchInput",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              id: "pageSearch",
                                              type: "text",
                                              placeholder:
                                                "Search by page name or ID",
                                            },
                                            domProps: {
                                              value: _vm.pageSearchInput,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.pageSearchInput =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-3" }, [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.statusFilter,
                                                  expression: "statusFilter",
                                                },
                                              ],
                                              staticClass: "form-select",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.statusFilter = $event
                                                    .target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    selected: "",
                                                    value: "",
                                                  },
                                                },
                                                [_vm._v("All")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "0" } },
                                                [_vm._v("Active")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                { attrs: { value: "1" } },
                                                [_vm._v("Inactive")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary mt-4",
                                        on: { click: _vm.displayImportPage },
                                      },
                                      [_vm._v("Import New")]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.isSearchedForPage
                                  ? _c("div", { staticClass: "row m-2 mt-0" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-9 overflow-auto",
                                          staticStyle: {
                                            "max-height": "520px",
                                            cursor: "pointer",
                                          },
                                        },
                                        _vm._l(
                                          _vm.filteredPages,
                                          function (page, index) {
                                            return _c(
                                              "ul",
                                              {
                                                key: page.PageID,
                                                staticClass: "list-group",
                                              },
                                              [
                                                _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "list-group-item",
                                                    class:
                                                      _vm.getPageClass(index),
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.pageClick(
                                                          page
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex w-100 justify-content-between",
                                                      },
                                                      [
                                                        _c(
                                                          "h6",
                                                          {
                                                            staticClass: "mb-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                page.PageName
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  page.OwnerType ===
                                                                    1
                                                                    ? " - Client Owned"
                                                                    : ""
                                                                ) +
                                                                " "
                                                            ),
                                                            page.HasWebhook
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-success",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        staticClass:
                                                                          "mt-3",
                                                                        attrs: {
                                                                          icon: "check",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(
                                                                      " Webhook"
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "small",
                                                      { staticClass: "mb-1" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(page.PageID) +
                                                            " - " +
                                                            _vm._s(
                                                              page.DomainName
                                                            ) +
                                                            " - "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            class:
                                                              page.Status === 0
                                                                ? "text-success"
                                                                : "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                page.Status ===
                                                                  0
                                                                  ? "ACTIVE"
                                                                  : "INACTIVE"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                        ]),
                  ])
                : _c("div", [
                    _c("div", { staticClass: "row m-3" }, [
                      _c("div", { staticClass: "col-md-9" }, [
                        _c("div", { staticClass: "list-group" }, [
                          _c("li", { staticClass: "list-group-item" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex w-100 justify-content-between",
                              },
                              [
                                _c("h6", { staticClass: "mb-1" }, [
                                  _vm._v(_vm._s(_vm.selectedPageName)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge bg-secondary rounded-pill",
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearPage()
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticStyle: {
                                        margin: "2px",
                                        "margin-right": "2px",
                                      },
                                      attrs: { icon: "xmark" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(_vm._s(_vm.updateRequest.PageID)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      !_vm.displayDomainSearch
                        ? _c("div", { staticClass: "row m-3" }, [
                            _c("div", { staticClass: "col-md-9" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "m-1",
                                  attrs: { for: "domain" },
                                },
                                [_vm._v("Selected Domain")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.updateRequest.DomainName,
                                      expression: "updateRequest.DomainName",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    disabled: "",
                                    id: "domain",
                                    placeholder: "Domain",
                                  },
                                  domProps: {
                                    value: _vm.updateRequest.DomainName,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.updateRequest,
                                        "DomainName",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-group-append" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary",
                                        attrs: { type: "button" },
                                        on: { click: _vm.changeDomainClick },
                                      },
                                      [_vm._v("Change")]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted small" },
                                [
                                  _vm._v(
                                    "Site ID: " + _vm._s(_vm.updateRequest.DDID)
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayDomainSearch
                        ? _c("div", { staticClass: "row m-3" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-8" }, [
                                _c(
                                  "label",
                                  { attrs: { for: "domainSearch" } },
                                  [_vm._v("Search for domains")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.domainSearchInput,
                                        expression: "domainSearchInput",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "domainSearch",
                                      placeholder: "Search for a domain",
                                    },
                                    domProps: { value: _vm.domainSearchInput },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.domainSearchInput =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "input-group-append" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          on: { click: _vm.searchPlatforms },
                                        },
                                        [_vm._v("Search")]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-1 mt-4" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    on: { click: _vm.cancelSearchPlatforms },
                                  },
                                  [_vm._v("Cancel")]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-9 m-3 overflow-auto",
                                  staticStyle: {
                                    "max-height": "520px",
                                    cursor: "pointer",
                                  },
                                },
                                _vm._l(
                                  _vm.platformSearchResults,
                                  function (witcoDomain, index) {
                                    return _c(
                                      "ul",
                                      {
                                        key: witcoDomain.Id,
                                        staticClass: "list-group",
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass: "list-group-item",
                                            class: _vm.getPageClass(index),
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.domainClick(
                                                  witcoDomain
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex w-100 justify-content-between",
                                              },
                                              [
                                                _c(
                                                  "h6",
                                                  { staticClass: "mb-1" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        witcoDomain.DomainName
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "mb-1 small" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    witcoDomain.Status === 0
                                                      ? "ACTIVE"
                                                      : "INACTIVE"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.displayPageProperties
                      ? _c("div", [
                          _vm.isWitcoOwned
                            ? _c("div", [
                                _c("div", { staticClass: "row m-3" }, [
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "m-1",
                                        attrs: { for: "about" },
                                      },
                                      [_vm._v("About/Bio")]
                                    ),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.updateRequest.About,
                                          expression: "updateRequest.About",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      staticStyle: { height: "150px" },
                                      attrs: {
                                        id: "about",
                                        placeholder: "About/Bio",
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.updateRequest.About,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.updateRequest,
                                            "About",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row m-3" }, [
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "m-1",
                                        attrs: { for: "Phone" },
                                      },
                                      [_vm._v("Phone")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.updateRequest.Phone,
                                          expression: "updateRequest.Phone",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "phone",
                                        placeholder: "Phone Number",
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.updateRequest.Phone,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.updateRequest,
                                            "Phone",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "form-text text-muted small",
                                      },
                                      [
                                        _vm._v(
                                          "Should start with the country code and only be numerical characters"
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row m-3" }, [
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "m-1",
                                        attrs: { for: "website" },
                                      },
                                      [_vm._v("Website URL")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.updateRequest.Website,
                                          expression: "updateRequest.Website",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "website",
                                        placeholder:
                                          "https://www.site-domain.com",
                                        required: "",
                                      },
                                      domProps: {
                                        value: _vm.updateRequest.Website,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.updateRequest,
                                            "Website",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "form-text text-muted small",
                                      },
                                      [
                                        _vm._v(
                                          "Should start with https:// or http://"
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row m-3" }, [
                            _c("div", { staticClass: "col-md-9" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary mt-3",
                                  attrs: { disabled: _vm.disableUpdate },
                                  on: { click: _vm.updateManagedPage },
                                },
                                [
                                  _vm.isUpdating
                                    ? _c("span", {
                                        staticClass:
                                          "spinner-border spinner-border-sm",
                                        attrs: {
                                          role: "status",
                                          "aria-hidden": "true",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                Update\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary mt-3",
                                  attrs: { disabled: _vm.disableUpdate },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clearPage()
                                    },
                                  },
                                },
                                [_vm._v("Cancel")]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
              _vm._v(" "),
              _vm.displaySuccess
                ? _c("div", [
                    _c("div", { staticClass: "row m-4" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-9 alert alert-success" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "display-1 text-success text-center",
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["far", "check-circle"] },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "h3",
                            { staticClass: "text-center text-success m-2" },
                            [_vm._v("Success!")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-center m-2" }, [
                            _vm._v(
                              "The page has been updated in Facebook and in our CINC system"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayPartialSuccess
                ? _c("div", [
                    _c("div", { staticClass: "row m-4" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-9 alert alert-warning" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "display-1 text-warning text-center",
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["far", "check-circle"] },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "h3",
                            { staticClass: "text-center text-warning m-2" },
                            [_vm._v("Partial Success")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-center m-2" }, [
                            _vm._v(_vm._s(_vm.updateResponseMessage)),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayError
                ? _c("div", [
                    _c("div", { staticClass: "row m-4" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-9 alert alert-danger" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "display-1 text-danger text-center",
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["far", "xmark"] },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "h3",
                            { staticClass: "text-center text-danger m-2" },
                            [_vm._v("Failure")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-center m-2" }, [
                            _vm._v(_vm._s(_vm.updateResponseMessage)),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row m-3 mt-5" }, [
      _c("div", { staticClass: "col-md-9 text-center" }, [
        _c("span", {
          staticClass: "spinner-grow spinner-grow-sm",
          attrs: { role: "status", "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Loading...")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-md-1 mt-4" }, [
      _c("p", { staticClass: "mt-2" }, [_vm._v(" - or - ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }